import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RouterSelectSingle } from 'academy-common-lib/features/filters/components/RouterSelectSingle';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistAssignmentsAssignedByFilter = () => {
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.topFilters.assignedBy.filterTitle"
    }),
    children: /*#__PURE__*/_jsx(RouterSelectSingle, {
      buttonUse: "link",
      filterType: "assignedBy",
      menuWidth: 170
    })
  });
};
export default PlaylistAssignmentsAssignedByFilter;